import { useEffect, useState } from 'react';

/**
 * @template T
 * @param {T} value
 * @param {number} [delayMilliseconds]
 * @returns {T}
 */
export function useDebounce(value, delayMilliseconds = 500) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedValue(value);
    }, delayMilliseconds);

    return () => clearTimeout(timerId);
  }, [value, delayMilliseconds]);

  return debouncedValue;
}
